import { Component, Injector, ViewEncapsulation, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { DataStateChangeEvent, GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { CommonService } from 'src/app-core/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { AppComponentBase } from '../app-component-base';
import { PopupFormComponent } from 'src/app/popup/popup-form/popup-form.component';
import { PopupService } from 'src/app/popup/popup.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-popup-list',
  templateUrl: './popup-list.component.html',
  styleUrls: ['./popup-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class PopupListComponent extends AppComponentBase implements OnInit {

  @ViewChild('grid', { static: true }) private grid: GridComponent;
  @Output() emitPopupList: EventEmitter<any> = new EventEmitter<any>();

  @Input() accountId: any;
  gridData: any;
  isFormLoading = false;
  notificationTypesList: any;
  statusValue = true;
  popupCount = 0;
  constructor(
    injector: Injector,
    private dialog: MatDialog,
    private commonService: CommonService,
    private  toastr: ToastrService,
    private popupService: PopupService,
    private router: Router
  ) {
    super(injector);
  }

  ngOnInit() {
    this.onRefreshGridData();
  }

  onRefreshGridData(): void {
    this.kendogridHelper.sort = [{ dir: 'desc', field: 'id' }];
    this.grid.dataStateChange.emit({
      skip: 0,
      take: this.kendogridHelper.defaultRecordsCountPerPage,
      filter: undefined,
      group: undefined,
      sort: this.kendogridHelper.sort,
    });
  }

  getGridRecords(event: DataStateChangeEvent): void {
    if (event) {
      this.kendogridHelper.dataStateChangeEvent(event);
    }
    let filterQuery = `&IsActive=${this.statusValue}`;
    filterQuery += `&AccountId=${this.accountId}`;   
    this.popupService.getPopupGridRecords(event, '', filterQuery)
    .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe(response => {
      this.kendogridHelper.setGridData(response.data);
      this.popupCount = response.data.items ? response.data.items.length : 0;
      this.emitPopupList.emit();
      this.kendogridHelper.hideLoadingIndicator();
    });
  }


  onAddEditPopup(dataItem?: any) {
    this.dialog.open(PopupFormComponent, {
      position: {
        right: '0',
      },
      panelClass: 'small_layout',
      hasBackdrop: false,
      data: {
        isEdit: dataItem ? true : false,
        popupData: dataItem ? dataItem : null,
        accountId: this.accountId ? this.accountId : null
      },
      autoFocus: false
    }).afterClosed().subscribe((response: any) => {
      if (response) {
        this.onRefreshGridData();
      }
    });
  }

  onRemovePopup(dataItem: any) {
    this.commonService.getConfirmationPopup
    (`You want to delete this popup.`,
      'Cancel', 'Confirm').then(result => {
        if (result) {
          this.onChangeStatus(dataItem);
        }
      });
  }


  onChangeStatus(dataItem: any): void {
    this.popupService.popupStatusUpdate({popupId: dataItem.id, IsActive: false}).subscribe((response: any) => {
      if (response.isSuccess) {
        this.toastr.success(dataItem.isActive ?
          'Popup Deactivated Successfully' : 'Popup activated Successfully');
        this.onRefreshGridData();
      }
    });
  }

  onToggleChange(value: string) {
    this.statusValue = value == 'true' ? true : false;
    this.onRefreshGridData();
  }

  onViewContact(dataItem: any): void {
    this.router.navigateByUrl(`app/contacts/contact-details/${dataItem.contactId}`);
  }

  onBack() {
    this.router.navigateByUrl(`app/admin/popups-notifications/5`);
  }

}

